import React, { useEffect } from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Box from "@mui/material/Box";
import Home from "../pages/Home";
import MapView from "../pages/MapView";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Login from "../pages/Login";
import ListPlaces from "../pages/ListPlaces";
import ViewPlace from "../pages/ViewPlace";
import CreatePlace from "../pages/CreatePlace";
import Dashboard from "../pages/Dashboard";
import SignUpForm from "../pages/Register";
import PlaceManagement from "../pages/PlaceManagement";
import Profile from "../pages/Profile";
import FavoriteList from "../pages/FavoritesList";
import ListUsers from "../pages/ListUsers";
import ListReservations from "../pages/ListReservations";

function App() {
  const { authToken, userRole, isLoading } = useAuth();

  useEffect(() => {}, [authToken]);

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <>
      <Router>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Header />
          
          <Box sx={{ flex: 1, overflow: "hidden" }}>
            {!isLoading && (
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/map" element={<MapView />} />
                <Route path="/places" element={<ListPlaces />} />
                <Route path="/places/:id" element={<ViewPlace />} />
                <Route path="/register" element={<SignUpForm />} />

                <Route
                  path="/login"
                  element={authToken ? <Navigate to="/" /> : <Login />}
                />
                <Route
                  path="/logout"
                  element={
                    authToken ? (
                      <Navigate
                        to="/"
                        replace={true}
                        state={{ from: "/logout" }}
                      />
                    ) : (
                      <Navigate to="/login" />
                    )
                  }
                />
                <Route
                  path="/profile"
                  element={authToken ? <Profile /> : <Navigate to="/login" />}
                />
                <Route
                  path="/favorites"
                  element={
                    authToken ? <FavoriteList /> : <Navigate to="/login" />
                  }
                />
                <Route
                  path="/places/new"
                  element={authToken ? <CreatePlace /> : <Navigate to="/" />}
                />
                <Route
                  path="/manage-places"
                  element={
                    authToken && userRole === "admin" ? (
                      <PlaceManagement />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    authToken && userRole === "admin" ? (
                      <Dashboard />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/listusers"
                  element={
                    authToken && userRole === "admin" ? (
                      <ListUsers />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
                <Route
                  path="/listreservations"
                  element={
                    authToken && userRole === "admin" ? (
                      <ListReservations />
                    ) : (
                      <Navigate to="/" />
                    )
                  }
                />
              </Routes>
            )}
          </Box>
          <Footer />
        </Box>
      </Router>
    </>
  );
}

export default App;
